import React, { useEffect, useState } from "react";
import { db, auth } from "../firebase";
import {
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import UserList from "./UserList";

const ChatBox = () => {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  const getConversationId = (uid1, uid2) => {
    return [uid1, uid2].sort().join("_");
  };

  useEffect(() => {
    if (!selectedUser) return;

    const convoId = getConversationId(auth.currentUser.uid, selectedUser.uid);
    const q = query(collection(db, "conversations", convoId, "messages"), orderBy("createdAt"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setMessages(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => unsubscribe();
  }, [selectedUser]);

  const handleSend = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user || !selectedUser) return;

    const convoId = getConversationId(user.uid, selectedUser.uid);
    await addDoc(collection(db, "conversations", convoId, "messages"), {
      text,
      uid: user.uid,
      email: user.email,
      createdAt: serverTimestamp()
    });
    setText("");
  };

  return (
    <div style={{ display: "flex", height: "100vh", fontFamily: "Arial, sans-serif" }}>
      <UserList onSelectUser={setSelectedUser} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <div style={{
          padding: "15px",
          borderBottom: "1px solid #ccc",
          backgroundColor: "#f2f2f2"
        }}>
          <h3 style={{ margin: 0 }}>
            {selectedUser ? `Chat with ${selectedUser.firstName} ${selectedUser.lastName}` : "Select a user"}
          </h3>
        </div>
        <div style={{
          flex: 1,
          overflowY: "auto",
          padding: "15px",
          backgroundColor: "#f0f0f0",
          display: "flex",
          flexDirection: "column",
        }}>
          {messages.map(msg => {
            const isMine = msg.uid === auth.currentUser?.uid;
            return (
              <div key={msg.id} style={{ display: "flex", flexDirection: "column", alignItems: isMine ? "flex-end" : "flex-start" }}>
                <div style={{
                  fontSize: "12px",
                  marginBottom: "4px",
                  color: "#888"
                }}>
                  {msg.createdAt?.toDate && new Date(msg.createdAt.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
                <div
                  style={{
                    alignSelf: isMine ? "flex-end" : "flex-start",
                    background: isMine ? "#007aff" : "#e5e5ea",
                    color: isMine ? "#fff" : "#000",
                    padding: "10px 14px",
                    borderRadius: "18px",
                    marginBottom: "10px",
                    maxWidth: "60%",
                    wordBreak: "break-word",
                  }}
                >
                  {msg.text}
                </div>
              </div>
            );
          })}
        </div>
        {selectedUser && (
          <form onSubmit={handleSend} style={{
            display: "flex",
            padding: "15px",
            backgroundColor: "#f2f2f2",
            borderTop: "1px solid #ccc"
          }}>
            <input
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Type a message..."
              style={{
                flex: 1,
                padding: "10px 15px",
                borderRadius: "20px",
                border: "1px solid #ccc",
                fontSize: "16px"
              }}
            />
            <button type="submit" style={{
              marginLeft: "10px",
              padding: "10px 20px",
              borderRadius: "20px",
              backgroundColor: "#007aff",
              color: "white",
              border: "none",
              fontWeight: "bold",
              cursor: "pointer"
            }}>
              Send
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ChatBox;